import { CHANNEL_RATINGS } from "./_lange-catalogue--reviews.js?v=channel-ratings-20261102";
import { paymentMethods } from "./_lange-catalogue--payment-marks.js";
function setLangeModuleTitle(fallback){const title=window.LANGE_NATIVE_SEO?.title||fallback;if(document.title!==title)document.title=title;}
import { isSetEligible } from "./_lange-catalogue--set-builder-core.js";
import { mobilePhoto } from "./_lange-catalogue--responsive-images.js";
import { TIERS, MAX_ITEMS, BUILDER_PATH, SHOP_PATH, HOME_PATH, DISCOVERY_PATH, getSelection, onSelectionChange, toggleProduct, removeProduct, clearSelection, setSelection, isSelected, summarise, formatPrice, loadCatalogue, bySlug, escapeHtml, productImage, productPath, hasLocalPackshot, productArtless, hasStudio2026Photography, studio2026Position, sortStudio2026First } from "./_lange-catalogue--set-builder-core.js";
import { header as siteHeader, footer as siteFooter, bindHeader, openBag, trustBadges } from "./_lange-catalogue--chrome.js";
import { addToBag } from "./_lange-catalogue--bag-store.js";
import { STARTERS, pickStarterSlugs, documentedness } from "./_lange-catalogue--composed-rituals.js";
const ROLE_LABELS = {
  'Day care': 'Day care',
  Serum: 'Serums',
  'Eye care': 'Eye care',
  'Night care': 'Night care',
  Mask: 'Masks',
  Treatment: 'Treatments',
  Lotion: 'Lotions'
};
const STARTER_RITUAL_IMAGES = {
  'carat-pair': {
    src: window.langeResolve('/lange/paris/sets/carat-pair-ritual-v7.webp'),
    alt: 'Phyto-Active Eye Mask and Phyto-Active Day Cream'
  },
  morning: {
    src: window.langeResolve('/lange/paris/sets/anti-ageing-day-pair-ritual-v7.webp'),
    alt: 'Nutri-Protection Day Cream and Prevention Serum'
  },
  'hydra-filling-pair': {
    src: window.langeResolve('/lange/paris/sets/hydra-filling-pair-ritual-v7.webp'),
    alt: 'Hydra-Filling Absolute Day Cream and Eye Gel'
  },
  'lifting-pair': {
    src: window.langeResolve('/lange/paris/sets/lifting-pair-ritual-v7.webp'),
    alt: 'Lift-Me Day Cream and Eye Contour Tensor Serum'
  },
  'fine-lines': {
    src: window.langeResolve('/lange/paris/sets/fine-lines-lifting-ritual-v7.webp'),
    alt: 'Lift-Me Day Cream, Remodeling Night Cream and Eye Contour Tensor Serum'
  },
  dryness: {
    src: window.langeResolve('/lange/paris/sets/global-hydrating-ritual-v7.webp'),
    alt: 'Hydra-Global Serum, day cream and night cream'
  },
  tighten: {
    src: window.langeResolve('/lange/paris/sets/tighten-loose-skin-ritual-v7.webp'),
    alt: 'Hydra-Filling Absolute Serum, Day Cream and Eye Gel'
  },
  eyes: {
    src: window.langeResolve('/lange/paris/sets/around-the-eyes-ritual-v7.webp'),
    alt: 'Phyto-Active Genius Eye Serum, Eye Mask and Day Cream'
  },
  'global-anti-ageing': {
    src: window.langeResolve('/lange/paris/sets/global-anti-ageing-ritual-v7.webp'),
    alt: 'Prevention Serum, Nutri-Protection Day Cream and Nourishing and Moisturizing Night Cream'
  }
};
const state = {
  products: [],
  role: 'All',
  concern: 'All',
  catalogue: {},
  size: (()=>{try{return Number(localStorage.getItem('lange.set-size.v1'))===2?2:3}catch{return 3}})(),
  tab: 'build'
};
const CONCERN_LABELS = {
  Firmness: 'Fine lines & firmness',
  'Eye area': 'The Eye area',
  Hydration: 'Dryness & hydration',
  Comfort: 'Sensitivity & comfort',
  Radiance: 'Dullness & radiance'
};
const CORE_ROLES = ['Serum', 'Day care', 'Night care'];
const OCCASIONAL = new Set(['Mask', 'Treatment']);
const IMAGED = new Set();
async function detectImagery(products) {
  await Promise.all(products.map(product => new Promise(resolve => {
    if (product.image) {
      IMAGED.add(product.slug);
      resolve();
      return;
    }
    const probe = new Image();
    probe.onload = () => {
      IMAGED.add(product.slug);
      resolve();
    };
    probe.onerror = () => resolve();
    probe.src = window.langeResolve(productImage(product, 420));
  })));
}
function starterPicks(starter) {
  return pickStarterSlugs(starter, state.products, IMAGED);
}
function packMarkup(product, size) {
  if (!hasLocalPackshot(product)) return productArtless(product, 'lsb-artless');
  return `<img src="${productImage(product, Math.min(size, 420))}" ${size > 420 ? `srcset="${productImage(product, 420)} 420w, ${productImage(product, 720)} 720w" sizes="(max-width: 700px) 45vw, (max-width: 1000px) 28vw, 240px"` : ""} alt="${escapeHtml(({'serum-miracle-algo-actif':'Algo-Active Miracle Serum — Carat','creme-algo-active-de-nuit':'Algo-Active Night Cream by LANGÉ PARIS','gel-or-contour-des-yeux':'Eye Contour Gold Gel by LANGÉ PARIS','serum-tenseur-contour-des-yeux':'Eye Contour Tensor Serum by LANGÉ PARIS'})[product.slug]||'')}" loading="lazy" decoding="async"
    data-fallback="${escapeHtml(product.image || '')}">`;
}
function wireImageFallbacks(root, product) {
  root.querySelectorAll('img[data-fallback]').forEach(img => {
    img.addEventListener('error', () => {
      const fallback = img.dataset.fallback;
      if (fallback && img.src !== fallback) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = window.langeResolve(fallback);
        return;
      }
      const holder = img.closest('.lsb-card__image, .lsb-slot, .lsb-card');
      if (!holder) return;
      const slug = img.closest('.lsb-card')?.querySelector('[data-toggle]')?.dataset.toggle ?? img.closest('.lsb-slot')?.querySelector('[data-remove]')?.dataset.remove;
      const item = state.catalogue[slug] ?? product;
      holder.classList.add('is-artless');
      const plate = document.createElement('span');
      plate.className = 'lsb-artless';
      plate.innerHTML = window.langeResolve(`<b>LANGÉ</b><i>${escapeHtml(item?.officialBrief?.reference ?? item?.role ?? '')}</i>`);
      img.replaceWith(plate);
    });
  });
}
function header(bagCount = 0) {
  return siteHeader({
    current: 'builder',
    bagCount
  });
}
function footer() {
  return siteFooter();
}
function hero() {
  return `<section class="lsb-hero lsb-film-hero">
    <div class="lsb-film" aria-hidden="true"><picture><source media="(max-width:700px)" srcset="https://cdn.shopify.com/s/files/1/1078/3608/0468/files/lange-set-mobile-20261102.webp?v=1793587857"><img src="https://cdn.shopify.com/s/files/1/1078/3608/0468/files/lange-set-desktop-20261102.webp?v=1793587857" alt="" width="1920" height="1080" fetchpriority="high" decoding="async"></picture><video muted loop playsinline preload="none" aria-hidden="true" tabindex="-1" data-desktop="https://cdn.shopify.com/videos/c/o/v/f985961832f5423984ef13a488e15db2.mp4" data-mobile="https://cdn.shopify.com/videos/c/o/v/2744deb1da474ebabc7f43110f6f8151.mp4"></video></div>
    <div class="lsb-hero__copy"><p class="lsb-kicker">Build your set</p><h1>Your skin. Your formulas.<br><em>Your ritual.</em></h1><p class="lsb-short-lede">Choose 2 or 3 formulas</p>
    <div class="lsb-plates" role="group" aria-label="Choose your set size">${TIERS.map(t=>`<button class="lsb-plate${state.size===t.count?' is-selected':''}" type="button" data-set-size="${t.count}" aria-pressed="${state.size===t.count}"><span><i aria-hidden="true"></i>${t.count===2?'Any two':'Any three'}</span><strong>${formatPrice(t.price)}</strong><em class="lsb-offer-badge lsb-offer-badge--${t.count}">${t.count===2?'Most chosen':builderText('value')}</em></button>`).join('')}</div>
    <p class="lsb-film-note">Free delivery throughout Europe</p>
    <p class="lsb-film-exclusions"><a href="/version-1-tracked/en/skincare/?line=Platinium">Platinum</a> · <a href="/version-1-tracked/en/skincare/?line=Skin%20Matrix">Skin Matrix</a> · <a href="/collections/longevity">Longevity</a> — ${builderText('separate')}</p></div>
  </section>`;
}
function builderDetails(){return `<section class="lsb-builder-details"><p class="lsb-hero__lede">Full-size care, chosen by you. No fixed bundle and no combination that quietly costs more. But if you would rather try LANGÉ first, then start with the €39 Discovery Set.</p><a class="lsb-hero__discovery" href="${DISCOVERY_PATH}">Try the Discovery Set — €39 <span aria-hidden="true">→</span></a><p class="lsb-eligibility">Choose any formulas shown below. <a href="/version-1-tracked/en/skincare/?line=Platinium">Platinum</a> and <a href="/version-1-tracked/en/skincare/?line=Skin%20Matrix">Skin Matrix</a> are sold separately at full price and are not included in these set offers.</p><p>Formulated and made at our own site in the Cosmetic Valley</p></section>`;}
function reassurance() {
  return `
  <section class="lsb-why">
    <img class="lsb-why__bg" src="/lange/paris/editorial/actives-texture-1100.webp" alt="" aria-hidden="true" loading="lazy" decoding="async">
    <div class="lsb-why__inner">
      <div>
        <p class="lsb-kicker">Why we price it this way</p>
        <h2>Choose what your skin needs.<br><em>The price stays fair.</em></h2>
      </div>
      <div class="lsb-why__cols">
        <article>
          <h3>No combination penalty</h3>
          <p>Every formula counts the same toward your set, including the €118 ones. Choose on what your skin needs, not on what the pricing rewards.</p>
        </article>
        <article>
          <h3>Built for a real routine</h3>
          <p>Two formulas cover morning and evening. Three completes the routine with Eye care included — where fine lines often show first, sometimes even crow feet.</p>
        </article>
        <article>
          <h3>Nothing recurring</h3>
          <p>No subscription and no auto-renewal. When you want the set again, you build it again — probably differently.</p>
        </article>
      </div>
    </div>
  </section>`;
}
const SET_FAQS = [{
  q: 'Can I mix any formulas at all?',
  a: 'Any formula shown in the set builder. Serums, day and night creams, Eye care, masks and treatments all count the same toward your two or three.'
}, {
  q: 'What if I want more than three?',
  a: 'A set holds three. Build one, then build another — there is no limit on how many sets an order can hold, and each is priced the same way.'
}, {
  q: 'Are these full sizes?',
  a: 'Yes. Every formula in a set is the same size sold on its own product page. Nothing here is a miniature.'
}, {
  q: 'How do I know which to choose?',
  a: 'Every product page carries the full ingredient list, the texture and what consumer testing actually showed. If you would rather be guided, the ritual finder asks six questions and suggests a starting point.'
}];
function faq() {
  return `
  <section class="lsb-faq">
    <div class="lsb-faq__head">
      <p class="lsb-kicker">Before you build</p>
      <h2>Reasonable<br><em>questions.</em></h2>
    </div>
    <div class="lsb-faq__list">
      ${SET_FAQS.map((item, index) => `
        <details${index === 0 ? ' open' : ''}>
          <summary><span>${escapeHtml(item.q)}</span><i aria-hidden="true"></i></summary>
          <p>${escapeHtml(item.a)}</p>
        </details>`).join('')}
    </div>
  </section>`;
}
function starterCard(starter) {
  const picks = starterPicks(starter).map(slug => state.catalogue[slug]).filter(Boolean);
  if (picks.length < 2) return '';
  const ritualImage = STARTER_RITUAL_IMAGES[starter.id];
  const individual = picks.reduce((sum, product) => sum + Number(product.price || 0), 0);
  const tier = picks.length === 2 ? TIERS[0] : TIERS[1];
  return `
    <article class="lsb-starter" id="ritual-${starter.id}">
      <div class="lsb-starter__packs${ritualImage ? ' lsb-starter__packs--ritual' : ''}" style="--lsb-pack-count:${picks.length}">
        ${ritualImage ? `<img class="lsb-starter__ritual-image" src="${ritualImage.src}" alt="${ritualImage.alt}" loading="lazy" decoding="async">` : picks.map(product => hasLocalPackshot(product) ? `<span class="lsb-starter__pack"><img src="${productImage(product, 420)}" alt="${escapeHtml(product.name)}" loading="lazy" decoding="async" data-pack-fallback="${escapeHtml(product.image || '')}"></span>` : `<span class="lsb-starter__pack">${productArtless(product, 'lsb-artless')}</span>`).join('')}
      </div>
      <h3>${escapeHtml(starter.label)}</h3>
      <p>${escapeHtml(starter.blurb)}</p>
      <ul>${picks.map(product => `<li><span data-lange-native-role>${escapeHtml(ROLE_LABELS[product.role] ?? product.role)}</span> · ${escapeHtml(product.name)}</li>`).join('')}</ul>
      <p class="lsb-starter__value">
        <strong>${formatPrice(tier.price)}</strong>
        ${individual > tier.price ? `<s>${formatPrice(individual)}</s> separately` : ''}
      </p>
      <button type="button" data-starter="${starter.id}"${picks.some(product => product.inStock === false) ? ' disabled' : ''}>${picks.some(product => product.inStock === false) ? 'Out of stock' : `Choose this ${picks.length === 2 ? 'pair' : 'ritual'}`}</button>
    </article>`;
}
function startersSection() {
  const threes = STARTERS.filter(entry => entry.slugs.length === 3 && entry.slugs.every(isSetEligible));
  const tightIndex = threes.findIndex(entry => entry.id === 'tighten');
  const globalIndex = threes.findIndex(entry => entry.id === 'global-anti-ageing');
  if (tightIndex >= 0 && globalIndex >= 0) [threes[tightIndex], threes[globalIndex]] = [threes[globalIndex], threes[tightIndex]];
  const pairs = STARTERS.filter(entry => entry.slugs.length === 2 && entry.slugs.every(isSetEligible));
  return `
  <section class="lsb-starters" id="our-picks">
    <div class="lsb-starters__head">
      <p class="lsb-kicker">Composed rituals</p>
      <h2>Fine lines do not need<br><em>a crowded shelf.</em></h2>
      <p>These complete routines are composed around the concerns that often appear first: fine lines or wrinkles, less firmness and the Eye area with Crow feet. Choose the one that reflects your skin now, then use it as written.</p>
    </div>

    <div class="lsb-starters__band">
      <h3>Complete ritual · ${formatPrice(TIERS[1].price)}</h3>
      <span>Three products selected to complement each other.</span>
    </div>
    <div class="lsb-starters__grid">${threes.map(starterCard).join('')}</div>

    <div class="lsb-starters__band lsb-starters__band--pairs">
      <h3>Essential pair · ${formatPrice(TIERS[0].price)}</h3>
      <span>Two complementary formulas for a simpler morning-and-evening routine.</span>
    </div>
    <div class="lsb-starters__grid">${pairs.map(starterCard).join('')}</div>
  </section>`;
}
function setAdvice(chosen) {
  if (!chosen.length) return null;
  const roles = chosen.map(p => p.role);
  const missing = CORE_ROLES.filter(role => !roles.includes(role));
  const duplicated = [...new Set(roles.filter((role, i) => roles.indexOf(role) !== i))];
  if (duplicated.length) {
    const label = ROLE_LABELS[duplicated[0]] ?? duplicated[0];
    return {
      tone: 'warn',
      text: `Two ${String(label).toLowerCase()} formulas selected. A mix of steps gives broader daily care.`
    };
  }
  if (chosen.length < MAX_ITEMS && missing.length) {
    const next = missing[0];
    return {
      tone: 'hint',
      text: `A routine usually wants ${String(ROLE_LABELS[next] ?? next).toLowerCase()} as well.`,
      suggestRole: next
    };
  }
  if (chosen.length === MAX_ITEMS && !missing.length) {
    return {
      tone: 'good',
      text: 'Morning, evening and a serum underneath. That is a complete routine.'
    };
  }
  return null;
}
function suggestionFor(role, chosen) {
  const concerns = chosen.map(p => p.concern);
  return state.products.filter(p => p.role === role && p.price && !chosen.some(c => c.slug === p.slug)).sort((a, b) => {
    const shared = p => concerns.includes(p.concern) ? 1 : 0;
    return shared(b) - shared(a) || studio2026Position(a) - studio2026Position(b) || documentedness(b) - documentedness(a);
  })[0] ?? null;
}
function slot(product, index) {
  if (!product) {
    return `<li class="lsb-slot lsb-slot--empty"><span class="lsb-slot__index">${index + 1}</span><p>Empty</p></li>`;
  }
  return `<li class="lsb-slot">
    <span class="lsb-slot__index">${index + 1}</span>
    ${packMarkup(product, 420)}
    <div>
      <strong>${escapeHtml(product.name)}</strong>
    <span>${escapeHtml(ROLE_LABELS[product.role] ?? product.role)} · ${formatPrice(product.price)}</span>
    </div>
    <button type="button" data-remove="${escapeHtml(product.slug)}" aria-label="Remove ${escapeHtml(product.name)}">Remove</button>
  </li>`;
}
function summaryPanel() {
  const chosen=getSelection().map(slug=>state.catalogue[slug]).filter(Boolean);
  const total=chosen.reduce((sum,p)=>sum+Number(p.price||0),0),price=TIERS.find(t=>t.count===state.size).price;
  const ready=chosen.length===state.size;
  return `<button class="lsb-summary-toggle" type="button" aria-label="Your set" aria-expanded="false"></button><div class="lsb-summary__head"><p class="lsb-kicker">Your set</p><h2>${formatPrice(price)} <small>${chosen.length} / ${state.size}</small></h2></div>
    <div class="lsb-summary__details"><ul class="lsb-slots">${Array.from({length:Math.max(state.size,chosen.length)},(_,i)=>slot(chosen[i],i)).join('')}</ul>
    ${total>price?`<p class="lsb-summary__saving"><span>${formatPrice(total)} bought separately</span><strong>Save ${formatPrice(total-price)}</strong></p>`:''}
    ${chosen.length?`<div class="lsb-selected-rating">${channelRating(chosen.at(-1))}<span>${escapeHtml(chosen.at(-1).name)}</span></div>`:''}</div>
    <div class="lsb-summary__actions"><button class="lsb-add" type="button" data-add-set ${ready?'':'disabled'}>${ready?`Add the set — ${formatPrice(price)}`:builderText(chosen.length>state.size?'remove':'choose').replace('{n}',state.size)}</button>
    ${chosen.length?'<button class="lsb-clear" type="button" data-clear>Start again</button>':''}
    <div class="lc-purchase-trust lsb-order-assurance">${trustBadges()}${paymentMethods()}</div><p class="lsb-summary__status" role="status" aria-live="polite"></p></div>`;
}
function channelRating(product){const r=CHANNEL_RATINGS[product.slug];if(!r)return '';return `<a class="lsb-channel-rating" href="${productPath(product)}#lange-product-top-reviews"><span class="lsb-rating-stars" aria-hidden="true"><i style="width:${r.rating*20}%">★★★★★</i>★★★★★</span><b>${r.rating.toLocaleString(builderLocale,{minimumFractionDigits:1})}/5</b> <span>(${r.count})</span><small>${builderText('channels')}</small></a>`;}

function productCard(product) {
  const selected = isSelected(product.slug);
  const full = getSelection().length >= state.size && !selected;
  return `
    <article data-preview-product="${escapeHtml(product.slug)}" class="lsb-card${selected ? ' is-selected' : ''}${full ? ' is-disabled' : ''}">
      <div class="lsb-card__media"><a class="lsb-card__image" href="${productPath(product)}" tabindex="-1" aria-hidden="true">
        ${product.inStock === false ? '<span class="lc-popular-ribbon">Out of stock</span>' : ['Carat', 'Collagen Booster', 'Anti-Ageing'].includes(product.officialBrief?.line ?? product.category) ? '<span class="lc-popular-ribbon">Popular</span>' : ''}
        ${packMarkup(product, 720)}
      </a><button type="button" class="lsb-card__actives" data-preview-actives aria-expanded="false" aria-controls="lsb-actives-${escapeHtml(product.slug)}">${escapeHtml(activePreviewLabel())}</button></div>
      <div class="lsb-card__body">
        <p class="lsb-card__line">${escapeHtml(product.officialBrief?.line ?? product.category)}${sizeMarkup(product)}</p>
        <p class="lsb-card__role">${escapeHtml(ROLE_LABELS[product.role] ?? product.role)}<i>${escapeHtml(CONCERN_LABELS[product.concern] ?? product.concern)}</i></p>
        <h3><a href="${productPath(product)}">${escapeHtml(product.name)}</a></h3>
        ${channelRating(product)}
        <p class="lsb-card__benefit">${escapeHtml(product.commercialBenefits?.builder ?? product.officialBrief?.shortBenefit ?? product.benefitHeadline ?? '')}</p>
        <div class="lsb-card__foot">
          <span>${formatPrice(product.price)} on its own</span>
          <button type="button" data-toggle="${escapeHtml(product.slug)}" ${full || product.inStock === false ? 'disabled' : ''}
            aria-pressed="${selected}">
            ${product.inStock === false ? 'Out of stock' : selected ? 'In your set ✓' : full ? 'Set is full' : 'Add to set'}
          </button>
        </div>
      </div>
      <div class="lsb-card__preview" id="lsb-actives-${escapeHtml(product.slug)}" inert></div>
    </article>`;
}
function filters() {
  const roles = ['All', ...Object.keys(ROLE_LABELS).filter(role => state.products.some(p => p.role === role))];
  const concerns = ['All', ...Object.keys(CONCERN_LABELS).filter(c => state.products.some(p => p.concern === c))];
  return `
    <div class="lsb-filters__group">
      <span>What it is</span>
      <div>${roles.map(role => `
        <button class="lc-filter${state.role === role ? ' is-active' : ''}" type="button" data-role="${escapeHtml(role)}"
          aria-pressed="${state.role === role}">${escapeHtml(role === 'All' ? `All ${state.products.length}` : ROLE_LABELS[role])}</button>`).join('')}</div>
    </div>
    <div class="lsb-filters__group">
      <span>What it is for</span>
      <div>${concerns.map(concern => `
        <button class="lc-filter${state.concern === concern ? ' is-active' : ''}" type="button" data-concern="${escapeHtml(concern)}"
          aria-pressed="${state.concern === concern}">${escapeHtml(concern === 'All' ? 'Any concern' : CONCERN_LABELS[concern])}</button>`).join('')}</div>
    </div>`;
}
function visibleProducts() {
  const products=sortStudio2026First(state.products.filter(p=>(state.role==='All'||p.role===state.role)&&(state.concern==='All'||p.concern===state.concern)));
  const order=['Carat','Anti-Ageing','Hydra-Filling','Lifting and Firming','Collagen Booster','Hydra-Global','Urban Defense','Revitalizing'];
  return products.sort((a,b)=>{const rank=p=>{const i=order.indexOf(p.officialBrief?.line??p.category);return i<0?99:i};return rank(a)-rank(b)});
}
function renderSummary() {
  const panel = document.querySelector('.lsb-summary');
  if (!panel) return;
  panel.innerHTML = window.langeResolve(summaryPanel());
  wireImageFallbacks(panel);
  const summaryToggle=panel.querySelector('.lsb-summary-toggle');
  summaryToggle?.setAttribute('aria-expanded',String(panel.classList.contains('is-expanded')));
  summaryToggle?.addEventListener('click',()=>{const expanded=panel.classList.toggle('is-expanded');summaryToggle.setAttribute('aria-expanded',String(expanded))});
  panel.querySelectorAll('[data-remove]').forEach(button => {
    button.addEventListener('click', () => removeProduct(button.dataset.remove));
  });
  panel.querySelector('[data-clear]')?.addEventListener('click', clearSelection);
  panel.querySelectorAll('[data-toggle]').forEach(button => {
    button.addEventListener('click', () => toggleProduct(button.dataset.toggle));
  });
  panel.querySelector('[data-add-set]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    const chosen = getSelection().map(slug => state.catalogue[slug]).filter(Boolean);
    const individualTotal = chosen.reduce((sum, product) => sum + Number(product.price || 0), 0);
    const info = summarise(chosen.length, individualTotal);
    if (!info.price || chosen.length !== state.size || chosen.some(p=>p.inStock===false)) return;
    const added = await addToBag({
      id: -Date.now(),
      components: chosen.map(product => product.slug),
      slug: `set-of-${chosen.length}`,
      name: `Your set of ${chosen.length} formulas`,
      role: 'Build your set',
      price: info.price,
      image: chosen[0] ? productImage(chosen[0], 420) : '',
      note: chosen.map(product => product.name).join(' · '),
      inStock: true
    });
    if (!added) return;
    const status = panel.querySelector('.lsb-summary__status');
    if (status) status.textContent = 'Your set is in the bag. Delivery and two samples are included.';
    button.textContent = 'Added to your bag';
    button.disabled = true;
    openBag();
  });
}
function renderGrid() {
  const grid = document.querySelector('.lsb-grid');
  if (!grid) return;
  closeActivePreview();
  const products = visibleProducts();
  grid.innerHTML = window.langeResolve(products.length ? products.map(productCard).join('') : '<p class="lsb-empty">No formulas in that step.</p>');
  wireImageFallbacks(grid);
  bindActivePreviews(grid);
  grid.querySelectorAll('[data-toggle]').forEach(button => {
    button.addEventListener('click', () => {
      if(!isSelected(button.dataset.toggle)&&getSelection().length>=state.size)return;
      const result = toggleProduct(button.dataset.toggle);
      if (result.full) {
        const status = document.querySelector('.lsb-summary__status');
        if (status) status.textContent = `A set holds ${MAX_ITEMS} formulas. Remove one to swap it.`;
      }
    });
  });
  const bar = document.querySelector('.lsb-filters');
  if (bar) {
    bar.innerHTML = window.langeResolve(filters());
    bar.querySelectorAll('[data-role]').forEach(button => {
      button.addEventListener('click', () => {
        state.role = button.dataset.role;
        renderGrid();
      });
    });
    bar.querySelectorAll('[data-concern]').forEach(button => {
      button.addEventListener('click', () => {
        state.concern = button.dataset.concern;
        renderGrid();
      });
    });
  }
}
function page() {
  return `<div class="lc-site lsb-site">
    ${header()}
    <main>
      ${hero()}
      <div class="lsb-builder-tabs" role="tablist" aria-label="Build your set"><button id="lsb-tab-build" role="tab" aria-controls="choose" aria-selected="true" data-builder-tab="build">${builderText('build')}</button><button id="lsb-tab-rituals" role="tab" aria-controls="lsb-ritual-panel" aria-selected="false" tabindex="-1" data-builder-tab="rituals">${builderText('rituals')}</button></div><div id="lsb-ritual-panel" role="tabpanel" aria-labelledby="lsb-tab-rituals" hidden>${startersSection()}</div>
      <section class="lsb-layout" id="choose" role="tabpanel" aria-labelledby="lsb-tab-build">
        <div class="lsb-choose">
          <div class="lsb-choose__head">
            <p class="lsb-kicker">The collection</p>
            <h2>Choose your formulas</h2>
            <p class="lsb-choose__featured"><b>2026 studio collections first</b><span>Carat · Anti-ageing · Hydra-filling · Lifting</span></p>
          </div>
          <div class="lsb-filters"></div>
          <div class="lsb-grid"></div>
        </div>
        <aside class="lsb-summary" aria-label="Your set"></aside>
      </section>
      ${builderDetails()}
      ${reassurance()}
      ${faq()}
    </main>
    ${footer()}
  </div>`;
}
function bindPackFallbacks(root) {
  root.querySelectorAll('img[data-pack-fallback]').forEach(img => {
    img.addEventListener('error', () => {
      const fallback = img.dataset.packFallback;
      if (fallback && img.src !== fallback) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = window.langeResolve(fallback);
        return;
      }
      const plate = document.createElement('span');
      plate.className = 'lsb-pack-plate';
      plate.innerHTML = window.langeResolve('<b>LANGÉ</b>');
      img.replaceWith(plate);
    });
  });
}
function bindStarters() {
  document.querySelectorAll('[data-starter]').forEach(button => {
    button.addEventListener('click', () => {
      const starter = STARTERS.find(entry => entry.id === button.dataset.starter);
      if (!starter) return;
      const picks=starterPicks(starter);state.size=picks.length===2?2:3;persistSize();setSelection(picks);showBuilderTab('build');syncSizes();
      document.querySelector('#choose')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      const status = document.querySelector('.lsb-summary__status');
      if (status) status.textContent = 'Loaded — change anything you like.';
    });
  });
}
function scrollToRequestedSection() {
  const id = window.location.hash.slice(1);
  if (id !== 'choose' && id !== 'our-picks' && !STARTERS.some(starter => id === `ritual-${starter.id}`)) return;
  if(id==='our-picks'||id.startsWith('ritual-'))showBuilderTab('rituals');
  const jump = () => {
    const target = document.getElementById(id);
    if (!target) return;
    const headerHeight = document.querySelector('.lc-header')?.getBoundingClientRect().height || 64;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerHeight - 16);
    window.scrollTo({
      top,
      behavior: 'auto'
    });
  };
  window.requestAnimationFrame(jump);
  window.setTimeout(jump, 920);
}
async function start() {
  const app = document.getElementById('root');
  if (app) app.hidden = true;
  const nativeRoot = document.getElementById('lange-catalogue-root');
  const target = nativeRoot || document.createElement('div');
  if (!nativeRoot) {
    target.id = 'lange-catalogue-root';
    document.body.append(target);
  }
  const title = `Build your set — 2 for ${formatPrice(TIERS[0].price)}, 3 for ${formatPrice(TIERS[1].price)} | LANGÉ PARIS`;
  // The shared localization runtime owns the document language.
  setLangeModuleTitle(title);
  state.products = (await loadCatalogue()).filter(isSetEligible);
  state.catalogue = bySlug(state.products);
  state.products.forEach(p=>{if(p.image||hasLocalPackshot(p))IMAGED.add(p.slug)});
  if(getSelection().length>state.size)state.size=3;
  if (!state.products.length) {
    target.innerHTML = window.langeResolve(`<main class="lc-load-error"><a href="${HOME_PATH}" class="lc-mark"><strong>LANGÉ</strong><small>PARIS</small></a><h1>We could not load the collection.</h1><a class="lc-button" href="${SHOP_PATH}">View all face care</a></main>`);
    return;
  }
  target.innerHTML = window.langeResolve(page());
  renderGrid();
  renderSummary();
  bindBuilder();
  bindStarters();
  bindPackFallbacks(document.querySelector('.lsb-starters') ?? document);
  bindHeader();
  scrollToRequestedSection();
  window.setTimeout(() => {
    setLangeModuleTitle(title);
    if (window.scrollY < 2) scrollToRequestedSection();
  }, 700);
  onSelectionChange(() => {
    renderGrid();
    renderSummary();
  });
}
const BUILDER_LABELS={"en":["Best value","Build my own","Ready-made rituals","Sold separately","Choose {n} formulas","Remove one formula","Across our sales channels"],"fr":["Meilleur prix","Composer mon coffret","Rituels prêts à choisir","Vendus séparément","Choisissez {n} formules","Retirez une formule","Sur tous nos canaux de vente"],"pl":["Najlepsza cena","Komponuję własny zestaw","Gotowe rytuały","Sprzedawane osobno","Wybierz {n} kosmetyki","Usuń jeden kosmetyk","We wszystkich naszych kanałach sprzedaży"],"de":["Bester Preis","Selbst zusammenstellen","Fertige Pflegerituale","Separat erhältlich","Wählen Sie {n} Produkte","Entfernen Sie ein Produkt","Über alle unsere Vertriebskanäle"],"es":["Mejor precio","Crear mi set","Rituales preparados","Se venden por separado","Elige {n} fórmulas","Quita una fórmula","En todos nuestros canales de venta"],"it":["Miglior prezzo","Creo il mio set","Rituali già composti","Venduti separatamente","Scegli {n} formule","Rimuovi una formula","Su tutti i nostri canali di vendita"],"pt":["Melhor preço","Criar o meu conjunto","Rituais já preparados","Vendidos separadamente","Escolha {n} fórmulas","Remova uma fórmula","Em todos os nossos canais de venda"],"cs":["Nejlepší cena","Sestavit vlastní sadu","Hotové rituály","Prodáváno samostatně","Vyberte {n} přípravky","Odeberte jeden přípravek","Ze všech našich prodejních kanálů"],"hu":["Legjobb ár","Saját szettet állítok össze","Összeállított rutinok","Külön kaphatók","Válasszon {n} terméket","Távolítson el egy terméket","Összes értékesítési csatornánkon"],"ro":["Cel mai bun preț","Îmi creez setul","Ritualuri gata alese","Vândute separat","Alegeți {n} formule","Eliminați o formulă","Pe toate canalele noastre de vânzare"],"el":["Καλύτερη τιμή","Δημιουργώ το σετ μου","Έτοιμες ρουτίνες","Πωλούνται χωριστά","Επιλέξτε {n} συνθέσεις","Αφαιρέστε μία σύνθεση","Σε όλα τα κανάλια πωλήσεών μας"],"nl":["Beste prijs","Zelf samenstellen","Samengestelde routines","Apart verkrijgbaar","Kies {n} formules","Verwijder één formule","Via al onze verkoopkanalen"],"uk":["Найкраща ціна","Скласти власний набір","Готові ритуали","Продаються окремо","Виберіть {n} засоби","Видаліть один засіб","У всіх наших каналах продажу"],"sk":["Najlepšia cena","Zostaviť vlastnú sadu","Hotové rituály","Predávané samostatne","Vyberte {n} prípravky","Odstráňte jeden prípravok","Zo všetkých našich predajných kanálov"],"bg":["Най-добра цена","Създавам свой комплект","Готови ритуали","Продават се отделно","Изберете {n} продукта","Премахнете един продукт","Във всички наши канали за продажба"],"lt":["Geriausia kaina","Susikurti savo rinkinį","Paruošti ritualai","Parduodama atskirai","Pasirinkite {n} priemones","Pašalinkite vieną priemonę","Visuose mūsų pardavimo kanaluose"],"hr":["Najbolja cijena","Sastavi svoj set","Gotovi rituali","Prodaje se zasebno","Odaberite {n} proizvoda","Uklonite jedan proizvod","Na svim našim prodajnim kanalima"],"fi":["Paras hinta","Kokoa oma setti","Valmiit hoitorutiinit","Myydään erikseen","Valitse {n} tuotetta","Poista yksi tuote","Kaikissa myyntikanavissamme"],"lv":["Labākā cena","Izveidot savu komplektu","Gatavi rituāli","Pārdod atsevišķi","Izvēlieties {n} līdzekļus","Noņemiet vienu līdzekli","Visos mūsu pārdošanas kanālos"],"sv":["Bästa pris","Bygg mitt eget set","Färdiga rutiner","Säljs separat","Välj {n} produkter","Ta bort en produkt","I alla våra försäljningskanaler"]};
const builderLocale=(()=>{try{return JSON.parse(document.getElementById('lange-market-prices')?.textContent||'{}').locale||document.documentElement.lang||'en'}catch{return document.documentElement.lang||'en'}})();
function builderText(key){const keys=['value','build','rituals','separate','choose','remove','channels'],index=keys.indexOf(key),ids={value:'lce_56573a30fbdd',build:'lce_8c02f8e12bc7',rituals:'lce_c79a887274c0'};if(ids[key])for(const script of document.querySelectorAll('script[data-lange-editable-content]')){try{const field=JSON.parse(script.textContent).find(f=>f.id===ids[key]);if(field?.value!=null&&field.value!==BUILDER_LABELS.en[index])return field.value;}catch{}}return (BUILDER_LABELS[builderLocale.split('-')[0]]||BUILDER_LABELS.en)[index]||key;}
function persistSize(){try{localStorage.setItem('lange.set-size.v1',String(state.size))}catch{}}
function syncSizes(){document.querySelectorAll('[data-set-size]').forEach(b=>{const yes=Number(b.dataset.setSize)===state.size;b.classList.toggle('is-selected',yes);b.setAttribute('aria-pressed',String(yes));});}
function showBuilderTab(tab){state.tab=tab;document.querySelectorAll('[data-builder-tab]').forEach(b=>{const yes=b.dataset.builderTab===tab;b.setAttribute('aria-selected',String(yes));b.tabIndex=yes?0:-1;});document.getElementById('choose').hidden=tab!=='build';document.getElementById('lsb-ritual-panel').hidden=tab!=='rituals';}
function scrollToBuilderProducts(){
  showBuilderTab('build');
  requestAnimationFrame(()=>{
    const grid=document.querySelector('.lsb-grid');
    if(!grid)return;
    const header=document.querySelector('.lh-header')||document.querySelector('.lc-header');
    const offset=header?.getBoundingClientRect().height||0;
    const top=Math.max(0,grid.getBoundingClientRect().top+window.scrollY-offset-12);
    window.scrollTo({top,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
}
function bindBuilder(){
  document.querySelectorAll('[data-set-size]').forEach(b=>b.addEventListener('click',()=>{state.size=Number(b.dataset.setSize);persistSize();syncSizes();renderGrid();renderSummary();scrollToBuilderProducts();}));
  document.querySelectorAll('[data-builder-tab]').forEach(b=>{b.addEventListener('click',()=>showBuilderTab(b.dataset.builderTab));b.addEventListener('keydown',e=>{if(['ArrowRight','ArrowLeft','Home','End'].includes(e.key)){e.preventDefault();const next=e.key==='Home'?'build':e.key==='End'?'rituals':state.tab==='build'?'rituals':'build';showBuilderTab(next);document.querySelector(`[data-builder-tab="${next}"]`).focus();}})});
  const video=document.querySelector('.lsb-film video');if(!video)return;
  const motion=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width:700px)');
  const play=()=>{if(motion.matches||navigator.connection?.saveData){video.pause();video.removeAttribute('src');video.load();return;}const src=mobile.matches?video.dataset.mobile:video.dataset.desktop;if(video.getAttribute('src')!==src){video.src=src;video.muted=true;video.autoplay=true;}video.play().catch(()=>{});};
  video.addEventListener('playing',()=>video.classList.add('is-playing'));
  mobile.addEventListener('change',play);motion.addEventListener('change',play);
  const poster=document.querySelector('.lsb-film img');const ready=()=>requestAnimationFrame(()=>requestAnimationFrame(play));if(poster.complete)ready();else poster.addEventListener('load',ready,{once:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else play()});
}

// Product preview behavior is shared by every locale and builder entry point.
let activePreviewData;
let activePreviewPromise;
let activePreviewControls;
function readActivePreviewData() {
  try { return JSON.parse(document.getElementById('lange-builder-actives')?.textContent || 'null'); } catch { return null; }
}
async function getActivePreviewData() {
  if (activePreviewData) return activePreviewData;
  activePreviewData = readActivePreviewData();
  if (activePreviewData) return activePreviewData;
  // Legacy entry points use exactly the same server-localized data as the native route.
  if (!activePreviewPromise) activePreviewPromise = fetch((window.Shopify?.routes?.root || '/') + 'pages/build-your-set')
    .then(r => { if (!r.ok) throw Error('Preview unavailable'); return r.text(); })
    .then(html => JSON.parse(new DOMParser().parseFromString(html, 'text/html').getElementById('lange-builder-actives').textContent))
    .catch(error => { activePreviewPromise = null; throw error; });
  activePreviewData = await activePreviewPromise;
  return activePreviewData;
}
function activePreviewField(id, data) {
  const field = data.fields[id];
  if (!field) return '';
  // Existing edited English controls are already emitted on builder pages.
  // Keep their identities and read their current value, including intentionally empty values.
  if ((builderLocale || 'en').split('-')[0] === 'en') {
    if (!activePreviewControls) {
      activePreviewControls = new Map();
      for (const script of document.querySelectorAll('script[data-lange-editable-content]')) {
        try {
          for (const field of JSON.parse(script.textContent)) if (!field.native_locale && field.value != null && !activePreviewControls.has(field.id)) activePreviewControls.set(field.id, field.value);
        } catch {}
      }
    }
    if (activePreviewControls.has(id)) return activePreviewControls.get(id);
  }
  let value = field[1];
  if (window.langeDecodeNativeText) for (let i = 0; i < 3; i++) value = window.langeDecodeNativeText(value);
  return value;
}
function activePreviewLabel() {
  const data = activePreviewData || (activePreviewData = readActivePreviewData());
  return data ? activePreviewField(data.heading, data) : 'Key actives';
}
function sizeMarkup(product) {
  const size = product.volumeLabel || (Number(product.volumeMl) > 0 ? product.volumeMl + ' ml' : '');
  return size ? `<span class="lsb-card__size">${escapeHtml(size)}</span>` : '';
}
let previewCard, previewHoverTimer, previewCloseTimer, previewSequence = 0, previewPinned = false;
let previewFitTimer;
// Explicit taps/keyboard opens keep the complete compact card clear of fixed chrome.
// Hover never moves the page underneath the pointer.
function fitPinnedPreview(card) {
  clearTimeout(previewFitTimer);
  previewFitTimer = setTimeout(() => {
    if (previewCard !== card || !previewPinned || !card.isConnected) return;
    const rect = card.getBoundingClientRect();
    const header = document.querySelector('.lh-header');
    const summary = document.querySelector('.lsb-summary');
    const top = Math.max(0, header?.getBoundingClientRect().bottom || 0) + 4;
    const bottom = (summary && getComputedStyle(summary).position === 'fixed'
      ? Math.min(innerHeight, summary.getBoundingClientRect().top) : innerHeight) - 4;
    const available = bottom - top;
    if (rect.height > available || (rect.top >= top && rect.bottom <= bottom)) return;
    window.scrollBy({ top: rect.top - top - (available - rect.height) / 2,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }, 260);
}

const previewDismissedCards = new WeakSet();
function closeActivePreview() {
  clearTimeout(previewFitTimer);
  clearTimeout(previewHoverTimer); clearTimeout(previewCloseTimer); ++previewSequence;
  if (!previewCard) return;
  const card = previewCard, panel = card.querySelector('.lsb-card__preview'), trigger = card.querySelector('[data-preview-actives]');
  if (panel?.contains(document.activeElement)) trigger.focus({preventScroll:true});
  if (card.matches(':hover')) previewDismissedCards.add(card);
  else previewDismissedCards.delete(card);
  card.classList.remove('has-active-preview');
  panel?.classList.remove('is-visible');
  if (panel) panel.inert = true;
  trigger?.setAttribute('aria-expanded', 'false');
  previewCard = null; previewPinned = false;
}
async function openActivePreview(card, pin = false) {
  if (!pin && previewPinned && previewCard !== card) return;
  clearTimeout(previewHoverTimer); clearTimeout(previewCloseTimer);
  if (previewCard === card) { if (pin) { previewPinned = true; fitPinnedPreview(card); } return; }
  closeActivePreview();
  if (pin) previewDismissedCards.delete(card);
  const sequence = ++previewSequence;
  try {
    const data = await getActivePreviewData();
    if (sequence !== previewSequence || !card.isConnected) return;
    const product = data.products[card.dataset.previewProduct];
    if (!product?.actives?.length) return;
    const panel = card.querySelector('.lsb-card__preview'), trigger = card.querySelector('[data-preview-actives]');
    if (!panel.dataset.loaded) {
      const heading = activePreviewField(data.heading, data);
      panel.innerHTML = `<div class="lsb-card__preview-inner"><section class="lsb-active-preview" aria-label="${escapeHtml(heading)}"><div class="lsb-active-preview__head"><p>${escapeHtml(heading)}</p><button type="button" data-close-actives aria-label="${escapeHtml(data.close)}">×</button></div><ul>${product.actives.map(([name,benefit,photo]) => `<li><img src="${escapeHtml(data.photos[photo])}" alt="" width="36" height="36" decoding="async"><div><strong>${escapeHtml(activePreviewField(name,data))}</strong><span>${escapeHtml(activePreviewField(benefit,data))}</span></div></li>`).join('')}</ul></section></div>`;
      panel.querySelector('[data-close-actives]').addEventListener('click', closeActivePreview);
      panel.dataset.loaded = 'true';
    }
    previewCard = card; previewPinned = pin;
    panel.inert = false;
    trigger.setAttribute('aria-expanded', 'true');
    card.classList.add('has-active-preview');
    requestAnimationFrame(() => { if (previewCard === card) panel.classList.add('is-visible'); });
    if (pin) fitPinnedPreview(card);
  } catch {
    card.querySelector('[data-preview-actives]')?.setAttribute('aria-expanded', 'false');
  }
}
function bindActivePreviews(grid) {
  grid.querySelectorAll('[data-preview-product]').forEach(card => {
    card.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse' || previewDismissedCards.has(card)) return;
      clearTimeout(previewCloseTimer);
      previewHoverTimer = setTimeout(() => openActivePreview(card), 160);
    });
    card.addEventListener('pointerleave', () => {
      previewDismissedCards.delete(card);
      clearTimeout(previewHoverTimer);
      if (previewCard === card && !previewPinned && !card.contains(document.activeElement)) previewCloseTimer = setTimeout(closeActivePreview, 220);
    });
    card.addEventListener('focusout', event => {
      if (previewCard === card && !previewPinned && !card.contains(event.relatedTarget) && !card.matches(':hover')) previewCloseTimer = setTimeout(closeActivePreview, 220);
    });
    card.querySelector('[data-preview-actives]').addEventListener('click', () => {
      if (previewCard === card && previewPinned) closeActivePreview();
      else openActivePreview(card, true);
    });
  });
}
document.addEventListener('keydown', event => { if (event.key === 'Escape') closeActivePreview(); });
document.addEventListener('pointerdown', event => { if (previewCard && !previewCard.contains(event.target)) closeActivePreview(); });

start();
